<template>
  <div>
    <!-- 渠道列表弹窗 -->
    <div v-if="show" class="dialog-overlay" @click="$emit('close')">
      <div class="dialog channel-dialog" @click.stop>
        <div class="dialog-header">
          <h3>{{ $t('mobile.channelList.titleWithCount', { count: channelList.length }) }}</h3>
          <button class="close-btn" @click="$emit('close')">×</button>
        </div>

        <div class="dialog-content">
          <!-- 国家筛选（仅当 supplier=14 时显示，筛选值使用数据库 country_id） -->
          <div v-if="supplier === 14 || supplier === '14'" class="country-filter-section">
            <label class="filter-label">{{ $t('channelSelection.countryFilter') }}</label>
            <el-select
              v-model="selectedCountryCode"
              filterable
              clearable
              :placeholder="$t('channelSelection.searchCountry')"
              class="country-select"
              @change="handleCountryChange"
            >
              <el-option
                v-for="country in countries"
                :key="country.countryId"
                :label="`${country.nameCh} (${country.nameEn}) ID: ${country.countryId}`"
                :value="country.countryId"
              >
                <span>{{ country.nameCh }} ({{ country.nameEn }})</span>
                <span style="float: right; color: #8492a6; font-size: 13px">ID: {{ country.countryId }}</span>
              </el-option>
            </el-select>
          </div>

          <!-- 桌面端渠道表格 / 移动端卡片列表 -->
          <div
            v-if="!loading && channelList.length > 0"
            class="channel-grid"
          >
            <div class="channel-table-wrapper">
              <table class="channel-table">
                <thead>
                  <tr>
                    <th>{{ $t('channelSelection.headers.channelCode') }}</th>
                    <th>{{ $t('channelSelection.headers.status') }}</th>
                    <th>{{ $t('channelSelection.headers.price') }}</th>
                    <th>{{ $t('channelSelection.headers.numberSegment') }}</th>
                    <th>{{ $t('channelSelection.headers.location') }}</th>
                    <th>{{ $t('channelSelection.headers.lastSuccess') }}</th>
                    <th>{{ $t('channelSelection.headers.actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="channel in channelList" :key="channel.code" class="channel-table-row">
                    <td class="channel-code-cell"><span class="channel-code">{{ channel.code }}</span></td>
                    <td>
                      <span class="channel-badge" :class="getChannelStatusClass(channel.content)">
                        {{ channel.content }}
                      </span>
                    </td>
                    <td class="channel-price-cell">
                      <template v-if="hasActivity(channel)">
                        <div class="activity-price-line">
                          <span class="current-price">{{ getDisplayPrice(channel) }}</span>
                          <span class="original-price">{{ getOriginalPrice(channel) }}</span>
                        </div>
                        <div class="activity-tags table-activity-tags">
                          <span class="activity-tag">{{ getActivityName(channel) }}</span>
                          <span v-if="getDiscountAmount(channel)" class="save-tag">{{ $t('activity.saved', { amount: getDiscountAmount(channel) }) }}</span>
                        </div>
                      </template>
                      <template v-else>{{ getDisplayPrice(channel) }}</template>
                    </td>
                    <td class="text-ellipsis" :title="channel.numberSegment || $t('common.unlimited')">
                      {{ channel.numberSegment || $t('common.unlimited') }}
                    </td>
                    <td class="text-ellipsis" :title="channel.province || '无'">{{ channel.province || '无' }}</td>
                    <td class="channel-time text-ellipsis" :title="channel.lastSuccessTime || '无'">
                      {{ channel.lastSuccessTime || '无' }}
                    </td>
                    <td>
                      <button class="btn-channel-select table-select-btn"
                        @click="handleSelectChannel(channel)"
                        :disabled="selectLoading"
                        :class="getChannelStatusClass(channel.content)"
                      >
                        <span v-if="selectLoading" class="btn-spinner"></span>
                        <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none">
                          <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {{ $t('mobile.channelList.select') }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="mobile-channel-cards">
              <div
                v-for="channel in channelList"
                :key="channel.code"
                class="channel-card"
              >
                <!-- 渠道卡片头部 -->
                <div class="channel-card-header">
                  <div class="channel-header-left">
                    <span class="channel-code">{{ channel.code }}</span>
                    <span class="channel-badge" :class="getChannelStatusClass(channel.content)">
                      {{ channel.content }}
                    </span>
                  </div>
                </div>

                <!-- 渠道详细信息 -->
                <div class="channel-card-body">
                  <div class="channel-details-grid">
                    <div class="detail-item">
                      <div class="detail-label">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {{ $t('mobile.channelList.price') }}
                      </div>
                      <div class="detail-value channel-price">
                        <template v-if="hasActivity(channel)">
                          <div class="activity-price-line">
                            <span class="current-price">{{ getDisplayPrice(channel) }}</span>
                            <span class="original-price">{{ getOriginalPrice(channel) }}</span>
                          </div>
                          <div class="activity-tags">
                            <span class="activity-tag">{{ getActivityName(channel) }}</span>
                            <span v-if="getDiscountAmount(channel)" class="save-tag">{{ $t('activity.saved', { amount: getDiscountAmount(channel) }) }}</span>
                          </div>
                        </template>
                        <template v-else>{{ getDisplayPrice(channel) }}</template>
                      </div>
                    </div>

                    <div class="detail-item">
                      <div class="detail-label">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <path d="M22 16.92V7.08C22 6.61 21.74 6.19 21.33 6.01L12.33 2.01C12.12 1.92 11.88 1.92 11.67 2.01L2.67 6.01C2.26 6.19 2 6.61 2 7.08V16.92C2 17.39 2.26 17.81 2.67 17.99L11.67 21.99C11.88 22.08 12.12 22.08 12.33 21.99L21.33 17.99C21.74 17.81 22 17.39 22 16.92Z" stroke="currentColor" stroke-width="2"/>
                        </svg>
                        {{ $t('project.numberSegment') }}
                      </div>
                      <div class="detail-value">{{ channel.numberSegment || $t('common.unlimited') }}</div>
                    </div>

                    <div class="detail-item">
                      <div class="detail-label">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 4.16519 5.32387 6.05026 3.63604C7.93533 1.94821 10.4478 1 13 1C15.5522 1 18.0647 1.94821 19.9497 3.63604C21.8348 5.32387 23 7.61305 23 10Z" stroke="currentColor" stroke-width="2"/>
                          <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" stroke-width="2"/>
                        </svg>
                        {{ $t('channelSelection.headers.location') }}
                      </div>
                      <div class="detail-value">{{ channel.province || '无' }}</div>
                    </div>

                    <div class="detail-item">
                      <div class="detail-label">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                          <polyline points="12,6 12,12 16,14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {{ $t('channelSelection.headers.lastSuccess') }}
                      </div>
                      <div class="detail-value channel-time">{{ channel.lastSuccessTime || '无' }}</div>
                    </div>
                  </div>
                </div>

                <!-- 渠道操作按钮 -->
                <div class="channel-card-footer">
                  <button class="btn-channel-select"
                    @click="handleSelectChannel(channel)"
                    :disabled="selectLoading"
                    :class="getChannelStatusClass(channel.content)"
                  >
                    <span v-if="selectLoading" class="btn-spinner"></span>
                    <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{ $t('channelSelection.selectChannel') }}
                  </button>
                </div>
              </div>
            </div>

          </div>
          
          <div v-else-if="loading" class="loading-state">
            <div class="spinner"></div>
            <p>{{ $t('channelSelection.loadingChannels') }}</p>
          </div>
          
          <div v-else class="empty-state">
            <p>{{ $t('mobile.channelList.noChannels') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 快捷选择渠道弹窗 -->
    <div v-if="showQuickSelect" class="dialog-overlay" @click="$emit('close-quick')">
      <div class="dialog" @click.stop>
        <div class="dialog-header">
          <h3>{{ $t('channelSelection.quickSwitch') }}</h3>
          <button class="close-btn" @click="$emit('close-quick')">×</button>
        </div>
        <div class="dialog-content">
          <div v-if="selectLoading" class="loading-state">
            <div class="spinner"></div>
            <p>{{ $t('common.processing') }}</p>
          </div>
          <div v-else-if="quickChannelList.length > 0" class="channel-quick-list">
            <div 
              v-for="channel in quickChannelList" 
              :key="channel.code"
              class="channel-quick-item"
              :class="{ selected: selectedChannel && selectedChannel.code === channel.code }"
              @click="handleQuickSelect(channel)"
            >
              <div class="channel-info">
                <div class="channel-name">{{ channel.projectName + "【" + channel.code + "】" }}</div>
                <div class="channel-meta">
                  <span class="channel-price">
                    {{ $t('mobile.channelList.price') }}:
                    <template v-if="hasActivity(channel)">
                      <span class="current-price">{{ getDisplayPrice(channel) }}</span>
                      <span class="original-price">{{ getOriginalPrice(channel) }}</span>
                      <span class="activity-tag compact">{{ getActivityName(channel) }}</span>
                    </template>
                    <template v-else>{{ getDisplayPrice(channel) }}</template>
                  </span>
                  <span class="channel-segment">{{ $t('channelSelection.headers.location') }}: {{ channel.province }}</span>
                  <span class="channel-segment">{{ $t('channelSelection.headers.numberSegment') }}: {{ channel.numberSegment || $t('common.unlimited') }}</span>
                </div>
                <div class="channel-meta">
                  <span class="channel-price">{{ channel.content }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div v-else class="empty-state">
            <p>{{ $t('mobile.channelList.noChannelsHint') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { countries } from '@/data/countries'

export default {
  name: 'ChannelList',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showQuickSelect: {
      type: Boolean,
      default: false
    },
    channelList: {
      type: Array,
      default: () => []
    },
    quickChannelList: {
      type: Array,
      default: () => []
    },
    selectedChannel: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectLoading: {
      type: Boolean,
      default: false
    },
    supplier: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['close', 'close-quick', 'select-channel', 'quick-select', 'country-change'],
  setup(props, { emit }) {
    const selectedCountryCode = ref('')

    // 国家选择变化处理
    const handleCountryChange = () => {
      emit('country-change', selectedCountryCode.value)
    }

    return {
      selectedCountryCode,
      countries,
      handleCountryChange
    }
  },
  methods: {
    getChannelStatusClass(status) {
      if (status && ((status.includes('可用') && !status.includes('可用:0'))  || status.includes('available') || status.includes('正常'))) {
        return 'status-available';
      }
      return 'status-unavailable';
    },
    handleSelectChannel(channel) {
      this.$emit('select-channel', channel);
    },
    handleQuickSelect(channel) {
      this.$emit('quick-select', channel);
    },
    hasValue(value) {
      return value !== undefined && value !== null && value !== '';
    },
    hasActivity(row) {
      const discountAmount = Number(row?.discountAmount);
      const hasPositiveDiscount = !Number.isNaN(discountAmount) && discountAmount > 0;
      const hasDiscountPrice = this.hasValue(row?.discountUserMoney) && this.hasValue(row?.originalUserMoney) && String(row.discountUserMoney) !== String(row.originalUserMoney);
      return Boolean(row?.hasDiscountActivity || row?.discountActivityId || hasPositiveDiscount || hasDiscountPrice);
    },
    getDisplayPrice(row) {
      return this.hasValue(row?.discountUserMoney) ? row.discountUserMoney : row?.userMoney;
    },
    getOriginalPrice(row) {
      return this.hasValue(row?.originalUserMoney) ? row.originalUserMoney : row?.userMoney;
    },
    getDiscountAmount(row) {
      return this.hasValue(row?.discountAmount) ? row.discountAmount : '';
    },
    getActivityName(row) {
      return row?.discountActivityName || this.$t('activity.active');
    }
  }
}
</script>

<style scoped>
/* 渠道对话框 */
.channel-dialog {
  max-width: 1180px;
  width: 94%;
}

/* 国家筛选区域 */
.country-filter-section {
  margin-bottom: 20px;
  padding: 16px;
  background: linear-gradient(135deg, #F9FAFB 0%, #F3F4F6 100%);
  border-radius: 8px;
  border: 1px solid #E5E7EB;
}

.filter-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.country-select {
  width: 100%;
}

/* 桌面端渠道表格 */
.channel-grid {
  max-height: 60vh;
  overflow-y: auto;
  padding: 0 4px 4px;
}

.channel-table-wrapper {
  overflow-x: auto;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  background: white;
}

.channel-table {
  width: 100%;
  min-width: 980px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.channel-table th,
.channel-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #EEF2F7;
  color: #1F2937;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;
  vertical-align: middle;
}

.channel-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: linear-gradient(135deg, #F9FAFB 0%, #F3F4F6 100%);
  color: #6B7280;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.channel-table th:nth-child(1) { width: 110px; }
.channel-table th:nth-child(2) { width: 130px; }
.channel-table th:nth-child(3) { width: 170px; }
.channel-table th:nth-child(4) { width: 150px; }
.channel-table th:nth-child(5) { width: 120px; }
.channel-table th:nth-child(6) { width: 150px; }
.channel-table th:nth-child(7) { width: 110px; }

.channel-table th:last-child,
.channel-table td:last-child {
  position: sticky;
  right: 0;
  text-align: center;
  box-shadow: -8px 0 12px rgba(15, 23, 42, 0.06);
}

.channel-table th:last-child {
  z-index: 4;
  background: linear-gradient(135deg, #F9FAFB 0%, #F3F4F6 100%);
}

.channel-table td:last-child {
  z-index: 1;
  background: #FFFFFF;
}

.channel-table tbody tr:last-child td {
  border-bottom: none;
}

.channel-table-row {
  transition: background-color 0.2s ease;
}

.channel-table-row:hover,
.channel-table-row:hover td:last-child {
  background: #F9FAFB;
}

.channel-code-cell {
  font-weight: 700;
}

.channel-price-cell {
  color: #EF4444;
  font-weight: 700;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-activity-tags {
  gap: 4px;
  margin-top: 3px;
}

.table-activity-tags .activity-tag,
.table-activity-tags .save-tag {
  max-width: 78px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 2px 6px;
  font-size: 10px;
}

.table-select-btn {
  width: auto;
  min-width: 78px;
  padding: 6px 10px;
  font-size: 12px;
}

.mobile-channel-cards {
  display: none;
}

/* 渠道卡片 */
.channel-card {
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.channel-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: var(--primary-color);
}

.channel-card-header {
  padding: 12px 16px;
  background: linear-gradient(135deg, #F9FAFB 0%, #F3F4F6 100%);
  border-bottom: 1px solid #E5E7EB;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.channel-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.channel-code {
  font-size: 14px;
  font-weight: 600;
  color: #1F2937;
}

.channel-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.channel-badge.status-available {
  background: #D1FAE5;
  color: #065F46;
}

.channel-badge.status-unavailable {
  background: #FEE2E2;
  color: #991B1B;
}

.channel-card-body {
  padding: 16px;
}

.channel-details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #6B7280;
}

.detail-value {
  font-size: 14px;
  font-weight: 500;
  color: #1F2937;
  margin-left: 18px;
  max-width: 200px;
  overflow-x: auto;
  white-space: nowrap;
}

.channel-price {
  color: #EF4444;
  font-weight: 600;
}

.activity-price-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.current-price {
  color: #FF2D2D;
  font-weight: 800;
  text-shadow: 0 0 10px rgba(255, 45, 45, 0.22);
}

.original-price {
  color: #9CA3AF;
  font-size: 12px;
  font-weight: 500;
  text-decoration: line-through;
}

.activity-tags {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.activity-tag,
.save-tag {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.4;
}

.activity-tag {
  gap: 4px;
  border: 1px solid rgba(245, 158, 11, 0.55);
  background: linear-gradient(135deg, #111827 0%, #000000 55%, #7F1D1D 100%);
  color: #FDE68A;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18), inset 0 0 0 1px rgba(255, 255, 255, 0.06);
  letter-spacing: 0.02em;
}

.activity-tag::before {
  content: '🔥';
  font-size: 10px;
}

.activity-tag.compact {
  margin-left: 4px;
}

.save-tag {
  background: linear-gradient(135deg, #DC2626 0%, #991B1B 100%);
  color: #FFF7ED;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.22);
}

.channel-time {
  font-size: 12px;
  color: #6B7280;
}

.channel-card-footer {
  padding: 12px 16px;
  background: #F9FAFB;
  border-top: 1px solid #E5E7EB;
}

.btn-channel-select {
  width: 100%;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #667EEA 0%, #764BA2 100%);
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-channel-select:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-channel-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 快速选择列表 */
.channel-quick-list {
  max-height: 400px;
  overflow-y: auto;
}

.channel-quick-item {
  padding: 12px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.channel-quick-item:hover {
  background: #F9FAFB;
  border-color: var(--primary-color);
}

.channel-quick-item.selected {
  background: #EBF5FF;
  border-color: var(--primary-color);
}

.channel-name {
  font-size: 14px;
  font-weight: 600;
  color: #1F2937;
  margin-bottom: 8px;
}

.channel-meta {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #6B7280;
  margin-bottom: 4px;
}

/* 移动端样式 */
@media (max-width: 768px) {
  .channel-dialog {
    max-width: 100%;
    width: 100%;
    height: 100%;
    border-radius: 0;
    margin: 0;
  }
  
  .channel-grid {
    max-height: calc(100vh - 120px);
    padding: 4px;
  }

  .channel-table-wrapper {
    display: none;
  }

  .mobile-channel-cards {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .channel-details-grid {
    grid-template-columns: 1fr;
  }
}
</style>
